'use client';

import React, { useEffect } from 'react';
import HomeHeader from './components/HomeHeader';
import HeroSection from './components/HeroSection';
import LayananSection from './components/LayananSection';
import PortfolioSection from './components/PortfolioSection';
import KeunggulanSection from './components/KeunggulanSection';
import CTASection from './components/CTASection';
import HomeFooter from './components/HomeFooter';
import ChatWidget from './components/ChatWidget';
import './home.css';

export default function HomePage() {
  // Spotlight card mouse tracking — throttled via rAF
  useEffect(() => {
    let rafId: number | null = null;
    const handleMouseMove = (e: MouseEvent) => {
      if (rafId !== null) return; // Skip if a frame is already queued
      rafId = requestAnimationFrame(() => {
        const cards = document.querySelectorAll<HTMLElement>('.spotlight-card');
        cards.forEach(card => {
          const rect = card.getBoundingClientRect();
          card.style.setProperty('--mouse-x', `${e.clientX - rect.left}px`);
          card.style.setProperty('--mouse-y', `${e.clientY - rect.top}px`);
        });
        rafId = null;
      });
    };
    document.addEventListener('mousemove', handleMouseMove, { passive: true });
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      if (rafId !== null) cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <div className="min-h-screen" style={{ background: '#09090b', color: '#ffffff', fontFamily: 'var(--font-sans, "DM Sans", sans-serif)' }}>
      <HomeHeader />
      <main>
        <HeroSection />
        <LayananSection />
        <PortfolioSection />
        <KeunggulanSection />
        <CTASection />
      </main>
      <HomeFooter />
      <ChatWidget />
    </div>
  );
}
